import React, { useEffect } from 'react';
import styles from './O_TreePost.module.css';
import { useTree } from '../../../contexts/TreeContext';
import {
  useParams,
  useNavigate,
  useLocation,
  useSearchParams,
} from 'react-router-dom';
import { Q_Icon } from '@/components/Q_Quarks/Q_Icon/Q_Icon';
import A_Button from '@/components/A_Atoms/A_Button/A_Button';
import { PATHS } from '@/constants/paths';
import cn from 'classnames';
import W_ProgressBilling from '@/components/W_Wrappers/W_ProgressBilling/W_ProgressBilling';
import M_UserDonationListItem from '@/components/M_Molecules/M_UserDonationListItem/M_UserDonationListItem';
import Q_BlurEffect from '@/components/Q_Quarks/Q_BlurEffect/Q_BlurEffect';
import { useCapsules } from '@/hooks/useCapsules';

export default function O_TreePost() {
  const { getTreeById, setCurrentTree, currentTree } = useTree();
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const location = useLocation() as { state?: { capsuleId?: string } };
  const [searchParams] = useSearchParams();
  const { data: capsulesResponse } = useCapsules();

  useEffect(() => {
    if (id) {
      const tree = getTreeById(id);
      if (tree) {
        setCurrentTree(tree);
      }
    }
  }, [id, getTreeById, setCurrentTree]);

  const handleDonateClick = () => {
    const capsuleId =
      location.state?.capsuleId || searchParams.get('capsuleId') || undefined;
    const resolvedCapsuleId =
      capsuleId ||
      capsulesResponse?.data?.capsules?.find(
        (c: any) =>
          c.treeId === currentTree?.id || c.tree?.id === currentTree?.id
      )?.id;

    if (resolvedCapsuleId && currentTree?.id) {
      navigate(PATHS.CAPSULE_DONATION_FUNC(resolvedCapsuleId, currentTree.id));
      return;
    }
    if (currentTree?.id) {
      navigate(PATHS.CAPSULE_DONATION_FUNC('default', currentTree.id));
      return;
    }
  };

  if (!currentTree) {
    return <div>Дерево не найдено</div>;
  }

  const progressPercentage = Math.round(
    (currentTree.totalDonations / currentTree.cost) * 100
  );

  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <h3 className={styles.tree_name}>{currentTree.name}</h3>
        <div className={styles.tree_image_wrapper}>
          <img src={currentTree.image} alt={currentTree.name} />
        </div>
        <div className={styles.tree_location_wrapper}>
          <Q_Icon.LocationIcon width={24} height={24} fill='none' />
          <span className={cn(styles.tree_location_text, 'text-p-2')}>
            {currentTree.location}
          </span>
        </div>
        <p className={cn(styles.tree_description, 'text-p-2')}>
          {currentTree.description}
        </p>
      </div>
      <W_ProgressBilling
        progress={progressPercentage}
        totalDonations={currentTree.totalDonations}
        cost={currentTree.cost}
        donorsCount={currentTree.donorsCount || 0}
        showDonorsCount={true}
      />
      <div className={styles.donors_list}>
        {currentTree.donations.map(donation => (
          <M_UserDonationListItem
            key={donation.id}
            userName={donation.userName}
            donationAmount={donation.amount}
            userAvatar={donation.userAvatar}
          />
        ))}
      </div>
      {currentTree.totalDonations < currentTree.cost && (
        <div className={styles.button_wrapper}>
          <Q_BlurEffect />
          <A_Button
            variant='primary'
            size='large'
            type='button'
            onClick={handleDonateClick}
          >
            Внести свой вклад
          </A_Button>
        </div>
      )}
    </div>
  );
}
